import { useSearchParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import StrokeTitle from "../components/ui/StrokeTitle";
import BadWords from "../BadWords";
import Button from "../components/ui/Button";
import '../styles/pages/creation.scss'
import Characters from '../character.json';
import { Link } from "react-router-dom";
import html2canvas from 'html2canvas';



const Share = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [character, setCharacter] = useState('');
  const [color, setColor] = useState("")

  const [name, setName] = useState(searchParams.get('base64') || '');
  const [charClass, setClass] = useState('')
  const [charm, setCharm] = useState(searchParams.get('charm') || '');
  const [disgaeaCharm, setDChar] = useState(searchParams.get('dc') || '');

  

  const characters = Characters;

  const [hasBadWords, setBadWords] = useState([])

  const divRef = useRef(null);

  useEffect(()=>{
    const data = JSON.parse(atob(searchParams.get('data')))
    setName(data.name)
    setCharacter(data.character)
    setColor(data.color)
    setCharm(data.charm)
    setDChar(data.disgaeaCharm)
    setClass(data.charClass)
  },[])

  const handleDownload = () => {
    html2canvas(divRef.current).then((canvas) => {
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'image.png';
      link.click();
    });
  };

  return (
    <div className="page-container">
        <StrokeTitle text="Character Profile Creation"/>
        <section className="section-wrapper">
          <h2 className="section-header yellow-text">
            ■ Preview
          </h2>
          <div class="preview-image shared-version" ref={divRef}>
            {
              hasBadWords > 0 &&
              <div className="disclaimer">
                Please remove any innapropiate language from the fields above!
              </div>
            }
            <img class="preview-card" src={`${process.env.PUBLIC_URL}/img/img_card.jpg`}/>
            <img class="preview-character-cutin-bg" src={`${process.env.PUBLIC_URL}/img/cutin_bg.jpg`}/>
            {
              character &&
              <img class="preview-character-cutin-image" src={
                color === "" ?
                `${process.env.PUBLIC_URL}/img/character/ci_${character}.png` :
                `${process.env.PUBLIC_URL}/img/character/ci_${character}_0${color}.png`
              }/>
            }
            <img class="preview-character-cutin-frame" src={`${process.env.PUBLIC_URL}/img/cutin_frame.png`}/>
            {
              character &&
              <img class="preview-character-wf" src={
                color === "" ?
                `${process.env.PUBLIC_URL}/img/character/wf_${character}.png` :
                `${process.env.PUBLIC_URL}/img/character/wf_${character}_0${color}.png`
              }/>
            }
            <p class="preview-class_name">{charClass}</p>
            <p class="preview-name">{name}</p>
            <p class="preview-text-character">{charm}</p>
            <p class="preview-text-disgaea7">{disgaeaCharm}</p>
          </div>
          <div className="pair" style={{marginTop: '15px'}}>
            {
              hasBadWords.length === 0 && <>
                <Button text="Download " color="green" onClick={()=>handleDownload()}/>
                <a href={`https://twitter.com/intent/tweet?text=${'Profile%20Card%20%7C%20Disgaea%207%3A%20NISA%0A'}&url=${window.location.href}&hashtags=Disgaea7%20%23Disgaea`} target="_blank" rel="noopener noreferrer">
                  <Button text="Twitter" color="blue"/>
                </a>
              </>
            }
            <Link to='../creation'>
              <Button text="New Card " color="blue"/> 
            </Link>
          </div>
        </section>
    </div>
  )
}

export default Share;